<template>
  <div>
    
    <v-row>
      <v-col class="text-center">
        <span  style="font-size:20px;font-weight:bold;">Prendi un appuntamento! <br><span class="service">Scegli il servizio</span></span>
      </v-col>
    </v-row>

    <steps v-bind:currentStep='1'/>

    <v-row>
      <v-col>
        <p class="text-center">1. Seleziona il servizio</p>
      </v-col>
    </v-row>
    <v-row dense>
        <v-col v-for="service in services" :key="service.i" cols="12" lg="6" xs="12">
            <v-card dark v-on:click="setService(service)">
                <v-card-title class="headline headline-text" v-text="service.name"></v-card-title>
            </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>

import steps from "../components/steps"
import axios from "axios"
import { mutations, store } from "../store";

export default {
  name: 'Services',

  components: {
    steps
  },
  mounted(){
    mutations.completed = false
    axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/items`).then(
      response => {
        this.services = response.data.data
      }).catch(() =>{
        this.$router.push("/error");  
      })
  },
  data: () => ({
    step: 1,
    services:[],
    completed: store.completed,
  }),
  methods:{
    setService: function(service){
      mutations.setService(service)
      this.$router.push("/date");
    }
  }
};
</script>

<style scoped>
.service{
  color:rgb(64, 211, 230);
}

.headline-text{
  font-size:20px !important;
}

</style>